import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PayloadWithId} from "../../../../core/service/payload/payloadWithId";
import {DocumentModel} from "../../../common/api/model/document.model";
import {DocumentConverter} from "../../../common/api/converter/document.converter";
import {DocumentRepository} from "../../../common/impl/service/ngrx/document.repository";
import {AbstractActionService} from "../../../../core/service/v2/service/action/abstractAction.service";
import {CustomizeHttpUrlGenerator} from "../../../../../store/core/url/customizeHttpUrlGenerator";
import {Payload} from "../../../../core/service/payload/payload";

@Injectable()
export class DocumentTemplateGenerateDocumentService
    extends AbstractActionService<DocumentTemplateGenerateDocumentPayload, DocumentModel> {

    constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                httpClient: HttpClient,
                private converter: DocumentConverter,
                private repository: DocumentRepository) {
        super('DocumentTemplate', 'generate-document', customizeHttpUrlGenerator, httpClient);
    }

    protected onResponse(response: DocumentModel, payload: DocumentTemplateGenerateDocumentPayload) {
        this.repository.created(response);
    }

    protected buildResponse(response: any): DocumentModel {
        return this.converter.convert(response);
    }
}

export class DocumentTemplateGenerateDocumentPayload extends PayloadWithId {
    partnerId: number;
    placeHolders: DocumentTemplateGenerateDocumentPlaceHolderPayload[] = [];
    facts: DocumentTemplateGenerateDocumentFactsPayload[] = [];
}

export class DocumentTemplateGenerateDocumentPlaceHolderPayload implements Payload {
    text: string;
    value: string;
}

export class DocumentTemplateGenerateDocumentFactsPayload implements Payload {
    businessContextValue: string;
    value: any;
}